import {maintenanceHandler} from '@web/middlewares/maintenanceHandler'

const maintenanceHandlerMiddleware = maintenanceHandler()

export default maintenanceHandlerMiddleware
